import './ScheduleUpdate.scss'
import { useTranslation } from 'react-i18next'
import { SoftwareVersion } from '../SoftwareVersionsComponent/SoftwareVersions.component'
import { useEffect, useState } from 'react'
import { ISelectOptions } from 'aw-combobox'
import { IToastProps, NotificationToast } from 'aw-notificationtoast'
import { Form, Spinner, Table } from 'react-bootstrap'
import Select from 'react-select'
import { Machine } from '../../utils/models/Machine'
import { getAllInstalations } from '../../utils/services/instalation.service'
import { useSelector } from 'react-redux'
import { selectUser } from '../../utils/redux/userSlice'
import { formatDate, getTodayDate } from 'aw-date-functions'
import { Instalation } from '../../utils/models/Instalation'
import { getAllMachines } from '../../utils/services/machine.service'
import { getRandomNumber } from 'aw-generic-functions'
import { AWSelect } from 'aw-select'

const ScheduleUpdate = (props: { versions: SoftwareVersion[] }) => {

    const { t } = useTranslation()
    const [toast, setToast] = useState<IToastProps>({ showToast: false, msg: '', fail: false })
    const [loading, setLoading] = useState(false)

    const [versions, setVersions] = useState<ISelectOptions[]>([])
    const [scheduleVersion, setScheduleVersion] = useState<ISelectOptions | null>(null)
    const [selectedFilteredVersion, setSelectedFilteredVersion] = useState<ISelectOptions | null>(null);

    const [scheduleHour, setScheduleHour] = useState('')

    const [allInstallations, setAllInstallations] = useState<ISelectOptions[]>([])
    const [filtredInstallation, setFiltredInstallation] = useState<ISelectOptions | null>(null);

    const [selectedMachines, setSelectedMachines] = useState<number[]>([]);
    const [allMachines, setAllMachines] = useState<Machine[]>([])
    const [allChecked, setAllChecked] = useState(false)

    const user = useSelector(selectUser)

    useEffect(() => {
        getAllInstalations(user.token)
            .then((installations: Instalation[]) => {
                setAllInstallations(installations.map(i => ({ value: i.idinstalation, label: i.name })));
            })
            .catch(e => console.log('Error get installations', e));

        getAllMachines(user.token)
            .then((machines: Machine[]) => setAllMachines(machines))
            .catch(e => console.log('Error get machines', e));
    }, [user.token]);

    useEffect(() => {
        if (props.versions.length > 0) {
            const vObj: ISelectOptions[] = []
            props.versions.forEach((v) => {
                vObj.push({ value: v.idversion, label: v.version })
            })
            setVersions(vObj)
        }
    }, [props.versions])

    const onClickUpdate = () => {
        if (!scheduleVersion || !scheduleHour) {
            showToastTimeOut(t('Please select a version and time'), true);
            return;
        }
        setLoading(true);
        try {
            const today = getTodayDate();
            const when = new Date(`${today}T${scheduleHour}`);
            allMachines.forEach(m => {
                if (selectedMachines.includes(m.idmachine)) {
                    (m as any).scheduled_version_id = Number(scheduleVersion.value);
                    (m as any).scheduled_datetime = when;
                }
            });

            showToastTimeOut(t('UpdateScheduled'), false);
        } finally {
            setLoading(false);
        }
    }

    const onAllCheckClick = (checked: boolean) => {
        setAllChecked(checked);
        if (checked) {
            const ids = allMachines.map(m => m.idmachine);
            setSelectedMachines(ids);
        } else {
            setSelectedMachines([]);
        }
    };

    const onCheckMachineClick = (checked: boolean, machineId: number) => {
        if (checked) setSelectedMachines(prev => [...prev, machineId]);
        else setSelectedMachines(prev => prev.filter(id => id !== machineId));
    };

    const showToastTimeOut = (msg: string, failToast: boolean) => {
        setToast({ showToast: true, msg: msg, fail: failToast })
        setTimeout(() => setToast({ showToast: false, msg: msg, fail: failToast }), 2000)
    }

    return (
        <>
            <NotificationToast showToast={toast.showToast} msg={toast.msg} fail={toast.fail} />
            <div id='ScheduleUpdateContainer' className="rounded-1 p-2">
                <p className="mt-1 h4 text-center">{t('ScheduleUpdate')}</p>
                <div className='d-flex flex-column gap-3 p-1'>
                    <section className='d-flex flex-row justify-content-between align-items-end'>
                        <section className='w-50'>
                            <Form.Label className='mb-0'>{t('Version')}</Form.Label>
                            <AWSelect closeMenuOnSelect={true} className="inputStyle selectStyle" value={scheduleVersion} onChange={(opt: ISelectOptions | null) => setScheduleVersion(opt)} options={versions} />
                        </section>
                        <section className='w-25'>
                            <Form.Label className='mb-0'>{t('Hour')}</Form.Label>
                            <Form.Control name="scheduleHour" disabled={loading} type="time" value={scheduleHour} onChange={(e: any) => setScheduleHour(e.target.value)} />
                        </section>
                    </section>
                    <section className='d-flex flex-row justify-content-between align-items-center'>
                        <section className='d-flex flex-row'>
                            <span className='me-2'>{`${t('Machines')}: `}</span>
                            <span>{`${selectedMachines.length} ${t('SelectedToUpdate')} `}</span>
                        </section>
                        <button className='btn-Custom btn-IDGreen' disabled={loading} onClick={onClickUpdate}>{t('Update')}</button>
                    </section>
                    <hr />
                </div>
                <div className="d-flex flex-column gap-3 p-1">
                    <section className='d-flex flex-row justify-content-between align-items-end'>
                        <section className='w-25'>
                            <Form.Label className='mb-0'>{t('Filters')}</Form.Label>
                            <AWSelect closeMenuOnSelect={true} clearable className="inputStyle selectStyle" placeholder={t('Version')} value={selectedFilteredVersion} onChange={(opt: ISelectOptions | null) => setSelectedFilteredVersion(opt)} options={versions} />
                        </section>
                        <section className='w-25'>
                            <Form.Label className='mb-0'></Form.Label>
                            <AWSelect closeMenuOnSelect={true} clearable className="inputStyle selectStyle" placeholder={t('Installation')} value={filtredInstallation} onChange={(opt: ISelectOptions | null) => setFiltredInstallation(opt)} options={allInstallations} />
                        </section>
                    </section>
                </div>
                {loading ? <div className="text-center pt-5"><Spinner animation="border" style={{ color: 'var(--accent-color)' }} /></div> : <div className="table-responsive scrollSorfVer p-2  mt-3">
                    <Table hover className="gridsStyle">
                        <thead>
                            <tr>
                                <th>{t('Name')}</th>
                                <th>{t('Installation')}</th>
                                <th>{t('CurVer')}</th>
                                <th>{t('SchVer')}</th>
                                <th>{t('SchHour')}</th>
                                <th><Form.Check name="active" type="checkbox" label={t('All')} checked={allChecked} onChange={(e: any) => onAllCheckClick(e.target.checked)} /></th>
                            </tr>
                        </thead>
                        {(allMachines.length > 0) ? <tbody>
                            {allMachines.map((m, i) => {
                                const hour = getRandomNumber(0, 24);
                                const minute = getRandomNumber(0, 60);
                                
                                const randomHour = 
                                  (hour < 10 ? "0" + hour : hour) + ":" + 
                                  (minute < 10 ? "0" + minute : minute);
                                return (<tr key={i} className={`tableLine`}>
                                    <td>{m.name}</td>
                                    <td>{m.instalation.name}</td>
                                    <td>{m.v_firmware_hmi || ''}</td>
                                    <td>{'1.1.0'}</td>
                                    <td>{randomHour}</td>
                                    <td className="text-end col-1"><Form.Check name="active" type="checkbox" checked={selectedMachines.includes(m.idmachine)} onChange={(e: any) => onCheckMachineClick(e.target.checked, m.idmachine)} /></td>
                                </tr>)
                            })}
                        </tbody> : <tbody>
                            <tr>
                                <td colSpan={6} className="text-center">{t('NoMachines')}</td>
                            </tr>
                        </tbody>}
                    </Table>
                </div>}
            </div>
        </>
    )
}

export default ScheduleUpdate
